import { GetVehicleType, GetVehicle, GetServiceCategory } from "../../Services";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Data } from "@react-google-maps/api";
// import GetVehicle from "../../Services";

const AddVehicle = ({
  editingVehicle,
  setEditingVehicle,
  setVehicles,
  setShowModal,
  driverId,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { driver } = location.state || {};

  const [formData, setFormData] = useState({
    model: "",
    plate_no: "",
    year: "",
    km_per_litter: "",
    color: "",
    service_category_id: "",
    owner_name: "",
    insurance_status: false,
    vehicle_type_id: "",
    driver_id: driverId || driver?.id || "",
  });
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [photo, setPhoto] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const fileInputRef = useRef(null);

  // Fetch vehicle types
  useEffect(() => {
    const fetchVehicleTypes = async () => {
      try {
        // const res = await axios.get(
        //   "https://binberu.idaprocharity.com/api/v1/admin/get-vehicle-type"
        // );

        const res = await GetVehicleType.fetchVehicleType();

        setVehicleTypes(res.data.data || res.data);

        // console.log("vehicle type: ", vehicleTypes);
      } catch (error) {
        console.error("Error fetching vehicle types:", error);
        // toast.error("Failed to fetch vehicle types", {
        //   position: "top-right",
        //   autoClose: 3000,
        // });
      }
    };
    fetchVehicleTypes();
  }, []);

  // Fetch vehicle types
  useEffect(() => {
    const fetchServiceTypes = async () => {
      try {
        // const res = await axios.get(
        //   "https://binberu.idaprocharity.com/api/v1/admin/get-vehicle-type"
        // );

        const res = await GetServiceCategory.fetchServiceCategoryName();

        setServiceTypes(res);

        // console.log("Service type: ", serviceTypes);
      } catch (error) {
        console.error("Error fetching Service types:", error);
        // toast.error("Failed to fetch vehicle types", {
        //   position: "top-right",
        //   autoClose: 3000,
        // });
      }
    };
    fetchServiceTypes();
  }, []);

  // Initialize form with editingVehicle data
  useEffect(() => {
    if (editingVehicle) {
      setFormData({
        model: editingVehicle.model || "",
        plate_no: editingVehicle.plate_no || "",
        year: editingVehicle.year || "",
        km_per_litter: editingVehicle.km_per_litter || "",
        color: editingVehicle.color || "",
        service_category_id: editingVehicle.service_category_id || "ECONOMY",
        owner_name: editingVehicle.owner_name || "",
        insurance_status: editingVehicle.insurance_status || false,
        vehicle_type_id: editingVehicle.vehicle_type_id || "",
        driver_id: editingVehicle.driver_id || driverId || driver?.id || "",
      });
      setPreviewImage(editingVehicle.photo_url || null);
    }
  }, [editingVehicle, driverId, driver]);

  // Initialize Bootstrap tooltips
  useEffect(() => {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, [photo]);

  // Handle form input changes
  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [id]: type === "checkbox" ? checked : value,
    });
  };

  // Handle photo upload (single file)
  const handleFile = (file) => {
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
      toast.error("File size must be less than 10MB", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (!["image/jpeg", "image/png"].includes(file.type)) {
      toast.error("Only .jpg and .png files are allowed", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    // console.log("Selected photo:", file.name);
    setPhoto(file);
    setPreviewImage(URL.createObjectURL(file));
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove("dragover");
    handleFile(e.dataTransfer.files[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.add("dragover");
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove("dragover");
  };

  const handleFileInputChange = (e) => {
    handleFile(e.target.files[0]);
    e.target.value = ""; // Reset to allow re-uploading the same file
  };

  const viewPhoto = () => {
    if (previewImage) {
      const modal = new window.bootstrap.Modal(
        document.getElementById("previewModal"),
      );
      modal.show();
    }
  };

  const removePhoto = () => {
    setPhoto(null);
    setPreviewImage(null);
    fileInputRef.current.value = "";
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      plate_no,
      model,
      year,
      km_per_litter,
      color,
      insurance_status,
      service_category_id,
      owner_name,
      vehicle_type_id,
      driver_id,
    } = formData;
    // console.log("hi", formData);
    if (
      !plate_no ||
      !model ||
      !year ||
      !km_per_litter ||
      !color ||
      !service_category_id ||
      !owner_name ||
      // !insurance_status ||
      !vehicle_type_id
      // !driver_id
    ) {
      toast.error("All required fields must be provided", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    const data = new FormData();
    data.append("plate_no", plate_no);
    data.append("model", model);
    data.append("year", year);
    data.append("km_per_litter", km_per_litter);
    data.append("color", color);
    data.append("service_category_id", service_category_id);
    data.append("owner_name", owner_name);
    data.append("insurance_status", insurance_status);
    // data.append("driver_id", driver_id);
    data.append("vehicle_type_id", vehicle_type_id);
    // if (photo) data.append("photo", photo);

    console.log("selected data: ", data);

    try {
      // const url = editingVehicle
      //   ? `https://binberu.idaprocharity.com/api/v1/admin/vehicles/${editingVehicle.id}`
      //   : "https://binberu.idaprocharity.com/api/v1/admin/add-vehicle";

      // console.log("dATA: ", data);
      const res = editingVehicle
        ? `https://binberu.idaprocharity.com/api/v1/admin/vehicles/${editingVehicle.id}`
        : await GetVehicle.createVehicle(data);

      // console.log("res: ", res);
      // console.log("URL: ", url);
      // const res = await axios({
      //   method: editingVehicle ? "PUT" : "POST",
      //   url,
      //   data,
      //   headers: { "Content-Type": "multipart/form-data" },
      // });

      // console.log("Vehicle saved:", res.data);

      console.log("Data: ", res.data);
      toast.success(
        `${
          editingVehicle ? "Vehicle updated" : "Vehicle created"
        } successfully!`,
        {
          position: "top-right",
          autoClose: 3000,
        },
      );

      // Update vehicles list if provided
      if (setVehicles) {
        if (editingVehicle) {
          setVehicles((prev) =>
            prev.map((v) => (v.id === editingVehicle.id ? res.data : v)),
          );
        } else {
          setVehicles((prev) => [...prev, res.data]);
        }
      }

      // Reset form
      setFormData({
        model: "",
        plate_no: "",
        year: "",
        km_per_litter: "",
        color: "",
        service_category_id: "",
        owner_name: "",
        insurance_status: false,
        vehicle_type_id: "",
        // driver_id: driverId || driver?.id || "",
      });
      setPhoto(null);
      setPreviewImage(null);
      setEditingVehicle(null);
      fileInputRef.current.value = "";

      // Delay modal closure to show toast
      if (setShowModal) {
        setTimeout(() => setShowModal(false), 1500);
      }
    } catch (err) {
      console.error("Error saving vehicle:", err.response?.data || err.message);
      toast.error(err.response?.data?.message || "Failed to save vehicle", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <div
      className="max-w-lg mx-auto bg-white p-6 shadow-md rounded-xl"
      style={{ maxHeight: "80vh", overflowY: "auto" }}
    >
      <h2 className="text-xl font-semibold mb-4">
        {editingVehicle ? "Edit Vehicle" : "Add Vehicle"}
      </h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group mb-4">
          <label htmlFor="model" className="col-form-label">
            Model *
          </label>
          <input
            type="text"
            className="form-control"
            id="model"
            value={formData.model}
            onChange={handleChange}
            placeholder="Enter Vehicle Model"
            required
          />
        </div>

        <div className="form-group mb-4">
          <label htmlFor="plate_no" className="col-form-label">
            Plate No *
          </label>
          <input
            type="text"
            className="form-control"
            id="plate_no"
            value={formData.plate_no}
            onChange={handleChange}
            placeholder="Enter Plate Number"
            required
          />
        </div>

        <div className="form-group mb-4">
          <label htmlFor="year" className="col-form-label">
            Year *
          </label>
          <input
            type="number"
            className="form-control"
            id="year"
            value={formData.year}
            onChange={handleChange}
            placeholder="Enter Year"
            required
          />
        </div>

        <div className="form-group mb-4">
          <label htmlFor="km_per_litter" className="col-form-label">
            KM per Litter *
          </label>
          <input
            type="text"
            className="form-control"
            id="km_per_litter"
            value={formData.km_per_litter}
            onChange={handleChange}
            placeholder="Enter KM per Litter"
            required
          />
        </div>

        <div className="form-group mb-4">
          <label htmlFor="color" className="col-form-label">
            Color
          </label>
          <input
            type="text"
            className="form-control"
            id="color"
            value={formData.color}
            onChange={handleChange}
            placeholder="Enter Color"
          />
        </div>

        <div className="form-group mb-4">
          <label htmlFor="vehicle_type_id" className="col-form-label">
            Vehicle Type *
          </label>
          <select
            className="form-control"
            id="vehicle_type_id"
            value={formData.vehicle_type_id}
            onChange={handleChange}
            required
          >
            <option value="">Select Vehicle Type</option>
            {vehicleTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group mb-4">
          <label htmlFor="service_type" className="col-form-label">
            Service Type *
          </label>
          <select
            className="form-control"
            id="service_category_id"
            value={formData.service_category_id}
            onChange={handleChange}
            required
          >
            <option value="">Select Service Type</option>

            {serviceTypes.length > 0 &&
              serviceTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
          </select>
        </div>

        <div className="form-group mb-4">
          <label htmlFor="owner_name" className="col-form-label">
            Owner Name *
          </label>
          <input
            type="text"
            className="form-control"
            id="owner_name"
            value={formData.owner_name}
            onChange={handleChange}
            placeholder="Enter Owner Name"
            required
          />
        </div>

        <div className="form-group mb-4">
          <label htmlFor="insurance_status" className="col-form-label">
            Insurance Status
          </label>
          <input
            className="ml-2"
            type="checkbox"
            id="insurance_status"
            name="insurance_status"
            checked={formData.insurance_status}
            onChange={handleChange}
          />
          <span className="ms-2 ml-1">Active</span>
        </div>

        <div className="form-group mb-4">
          <label htmlFor="photo" className="col-form-label">
            Photo
          </label>
          <div
            className="card border-dashed h-100"
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <div className="card-body text-center py-5">
              {previewImage ? (
                <img
                  src={previewImage}
                  alt="Vehicle preview"
                  className="photo-preview mb-3"
                />
              ) : (
                <>
                  <i className="fas fa-cloud-upload-alt fa-3x text-muted mb-3" />
                  <h5 className="card-title">Drag & Drop Photo Here</h5>
                  <p className="card-text text-muted">
                    Or click to browse (1 file, max 10MB, .jpg, .png)
                  </p>
                </>
              )}
              <input
                type="file"
                id="photo"
                accept=".jpg,.png"
                className="d-none"
                ref={fileInputRef}
                onChange={handleFileInputChange}
              />
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => fileInputRef.current.click()}
              >
                Browse
              </button>
            </div>
            {photo && (
              <div className="list-group list-group-flush">
                <div className="list-group-item d-flex justify-content-between align-items-center">
                  <span>
                    {photo.name} ({(photo.size / 1024).toFixed(2)} KB)
                  </span>
                  <div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary px-2 py-1 me-2"
                      onClick={viewPhoto}
                      data-bs-toggle="tooltip"
                      title="View"
                      aria-label="View photo"
                    >
                      <i className="fas fa-eye" />
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger px-2 py-1"
                      onClick={removePhoto}
                      data-bs-toggle="tooltip"
                      title="Remove"
                      aria-label="Remove photo"
                    >
                      <i className="fas fa-trash" />
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="card-footer d-flex justify-content-between mb-4">
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              setEditingVehicle(null);
              setShowModal(false);
            }}
          >
            Cancel
          </button>
        </div>
      </form>

      {/* Bootstrap Modal for Photo Preview */}
      <div
        className="modal fade"
        id="previewModal"
        tabIndex="-1"
        aria-labelledby="previewModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="previewModalLabel">
                Vehicle Photo Preview
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setPreviewImage(null)}
              ></button>
            </div>
            <div className="modal-body text-center">
              {previewImage && (
                <img
                  src={previewImage}
                  alt="Vehicle preview"
                  className="img-fluid"
                  style={{ maxHeight: "60vh" }}
                />
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => setPreviewImage(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddVehicle;
